import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "maps" }
const _hoisted_2 = { class: "mapv3-shell" }
const _hoisted_3 = { class: "mapv3-list__header" }
const _hoisted_4 = { class: "mapv3-list__head" }
const _hoisted_5 = { class: "mapv3-list__title" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "mapv3-list__search" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "mapv3-list__filters" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "mapv3-list__scroll" }
const _hoisted_12 = {
  key: 0,
  class: "mapv3-list__empty"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "mapv3-list__group-name" }
const _hoisted_15 = { class: "mapv3-list__group-count" }
const _hoisted_16 = { class: "mapv3-list__group-rows" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "mapv3-list__row-main" }
const _hoisted_19 = { class: "mapv3-list__plate" }
const _hoisted_20 = { class: "mapv3-list__driver" }
const _hoisted_21 = {
  key: 0,
  class: "mapv3-list__alerts"
}
const _hoisted_22 = { class: "mapv3-list__right" }
const _hoisted_23 = { class: "mapv3-controls" }
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "mapv3-controls__zoom" }
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "mapv3-map-controls__menu" }
const _hoisted_31 = { class: "mapv3-map-controls__title" }
const _hoisted_32 = { class: "mapv3-map-controls__styles" }
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!
  const _component_Mapv3InfoPanel = _resolveComponent("Mapv3InfoPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Map, { ref: "map" }, null, 512),
      _createElementVNode("aside", {
        class: _normalizeClass(["mapv3-list", { 'mapv3-list--collapsed': !_ctx.listOpen }]),
        "aria-label": "Lista pojazdów"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('aside.menu.pages.vehicles')), 1),
            _createElementVNode("button", {
              class: "mapv3-panel-close",
              type: "button",
              title: _ctx.$t('components.map.list.collapse'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.listOpen = false))
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
            ]))], 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
              class: "mapv3-list__search-input",
              type: "text",
              placeholder: _ctx.$t('components.map.list.searchPlaceholder'),
              autocomplete: "off"
            }, null, 8, _hoisted_8), [
              [_vModelText, _ctx.search]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: _normalizeClass(["mapv3-list__filter", { 'mapv3-list__filter--active': _ctx.listFilter === 'grouped' }]),
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.listFilter = 'grouped'))
            }, _toDisplayString(_ctx.$t('components.map.list.filters.grouped')), 3),
            _createElementVNode("button", {
              class: _normalizeClass(["mapv3-list__filter", { 'mapv3-list__filter--active': _ctx.listFilter === 'all' }]),
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.listFilter = 'all'))
            }, _toDisplayString(_ctx.$t('components.map.list.filters.all')) + " · " + _toDisplayString(_ctx.allCount), 3),
            _createElementVNode("button", {
              class: _normalizeClass(["mapv3-list__filter mapv3-list__filter--alert", { 'mapv3-list__filter--active': _ctx.listFilter === 'alert' }]),
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.listFilter = 'alert'))
            }, _toDisplayString(_ctx.$t('components.map.list.filters.alert')) + " · " + _toDisplayString(_ctx.alertCount), 3),
            _createElementVNode("span", {
              class: "mapv3-list__visible",
              title: _ctx.$t('components.map.list.visible')
            }, _toDisplayString(_ctx.visibleCount), 9, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (!_ctx.hasRows)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.vehicles.length ? _ctx.$t('components.map.list.empty') : _ctx.$t('components.map.list.loading')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderBlocks, (block) => {
            return (_openBlock(), _createElementBlock("section", {
              key: block.key,
              class: _normalizeClass(["mapv3-list__group", { 'is-collapsed': block.name && _ctx.collapsedGroups[block.key] }])
            }, [
              (block.name)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "mapv3-list__group-header",
                    type: "button",
                    onClick: ($event: any) => (_ctx.toggleGroup(block.key))
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-chevron-down mapv3-list__group-chevron" }, null, -1)),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(block.name), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(block.rows.length), 1)
                  ], 8, _hoisted_13))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.rows, (v) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: v.imei,
                    class: _normalizeClass(["mapv3-list__row", {
                  'mapv3-list__row--selected': v.imei === _ctx.selectedImei,
                  'mapv3-list__row--alert': v._alerts.length
                }]),
                    onClick: ($event: any) => (_ctx.selectVehicle(v))
                  }, [
                    _createElementVNode("span", {
                      class: "mapv3-list__icon",
                      style: _normalizeStyle({ background: v._palette.tint, color: v._palette.color })
                    }, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("i", { class: "bi bi-truck" }, null, -1)
                    ]))], 4),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(v._plate), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(v._driver), 1),
                      (v._alerts.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v._alerts, (a, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "mapv3-list__alert"
                              }, _toDisplayString(a), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: "mapv3-list__speed",
                        style: _normalizeStyle({ color: v._palette.color })
                      }, _toDisplayString(v._speedTxt), 5),
                      _createElementVNode("div", {
                        class: "mapv3-list__status",
                        style: _normalizeStyle({ color: v._status === 'alert' ? _ctx.alertColor : '' })
                      }, _toDisplayString(_ctx.statusLabel(v._status)), 5)
                    ])
                  ], 10, _hoisted_17))
                }), 128))
              ], 512), [
                [_vShow, !block.name || !_ctx.collapsedGroups[block.key]]
              ])
            ], 2))
          }), 128))
        ])
      ], 2),
      (!_ctx.listOpen)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "mapv3-panel-handle",
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.listOpen = true))
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-list" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('aside.menu.pages.vehicles')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedVehicle)
        ? (_openBlock(), _createBlock(_component_Mapv3InfoPanel, {
            key: 1,
            vehicle: _ctx.selectedVehicle,
            onClose: _ctx.closePanel
          }, null, 8, ["vehicle", "onClose"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: _normalizeClass(["mapv3-controls__center", { 'mapv3-controls__center--active': _ctx.routePlannerActive }]),
          type: "button",
          title: _ctx.$t('components.map.routePlanning.title'),
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleRoutePlanner && _ctx.toggleRoutePlanner(...args)))
        }, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("i", { class: "bi bi-sign-turn-right" }, null, -1)
        ]))], 10, _hoisted_24),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "mapv3-controls__btn mapv3-controls__btn--top",
            type: "button",
            title: _ctx.$t('components.map.controls.zoomIn'),
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.zoomIn && _ctx.zoomIn(...args)))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
          ]))], 8, _hoisted_26),
          _createElementVNode("button", {
            class: "mapv3-controls__btn",
            type: "button",
            title: _ctx.$t('components.map.controls.zoomOut'),
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.zoomOut && _ctx.zoomOut(...args)))
          }, [...(_cache[18] || (_cache[18] = [
            _createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1)
          ]))], 8, _hoisted_27)
        ]),
        _createElementVNode("button", {
          class: "mapv3-controls__center",
          type: "button",
          title: _ctx.$t('components.map.controls.fitFleet'),
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.fitFleet && _ctx.fitFleet(...args)))
        }, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("i", { class: "bi bi-fullscreen" }, null, -1)
        ]))], 8, _hoisted_28),
        _createElementVNode("div", {
          class: _normalizeClass(["mapv3-map-controls", { 'is-open': _ctx.controlsOpen }])
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["mapv3-map-controls__toggle", { 'mapv3-map-controls__toggle--active': _ctx.controlsOpen }]),
            type: "button",
            title: _ctx.$t('components.map.controls.settings'),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.controlsOpen = !_ctx.controlsOpen))
          }, [...(_cache[20] || (_cache[20] = [
            _createElementVNode("i", { class: "bi bi-sliders" }, null, -1)
          ]))], 10, _hoisted_29),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('components.map.controls.baseMap')), 1),
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableProviders, (p) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: p.id,
                  class: _normalizeClass(["mapv3-map-controls__style", { 'is-active': _ctx.selectedProvider === p.id }]),
                  type: "button",
                  onClick: ($event: any) => (_ctx.selectProvider(p.id))
                }, [
                  _createElementVNode("span", {
                    class: "mapv3-map-controls__style-preview",
                    style: _normalizeStyle({ background: p.preview })
                  }, null, 4),
                  _createElementVNode("span", null, _toDisplayString(p.label), 1)
                ], 10, _hoisted_33))
              }), 128))
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}